import Vue from "vue"
import VueRouter from "vue-router"
import Home from "../views/Home.vue"
import Role from "../views/Role.vue"
import Video from "../views/Video.vue"
import News from "../views/News.vue"
import Announcement from "../views/Announcement.vue"
import Guide from "../views/Guide.vue"
import QRCode from '../views/QRCode.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  {
    path: "/character",
    name: "Character",
    component: Role,
  },
  {
    path: "/video",
    name: "Video",
    component: Video,
  },
  {
    path: "/news",
    name: "News",
    component: News,
  },
  {
    path: "/announcement",
    name: "Announcement",
    component: Announcement,
  },
  {
    path: "/guide",
    name: "Guide",
    component: Guide,
  },
  {
    path: "/qrcode",
    name: "QRCode",
    component: QRCode
  }
]

const router = new VueRouter({
  // 这里只能使用 hash 模式，否则在基于cdn+存储桶的站点下，无法直接使用 url 打开页面
  // mode: "history",
  routes,
})

// 全局前置守卫
router.beforeEach((to, from, next) => {
  if (to.name === 'QRCode') {
    const ua = navigator.userAgent.toLowerCase()

    // 检查是否为 iOS 设备
    const isIOS = /iphone|ipad|ipod|mac/.test(ua)
    // 检查是否为 Android 设备
    const isAndroid = /android|linux/.test(ua)
    // 检查是否为 HarmonyOS 设备
    const isHarmonyOS = /harmonyos|huawei/.test(ua)

    if (isIOS) {
      window.location.href = 'https://apps.apple.com/cn/app/id6497877633'
    } else if (isAndroid) {
      window.location.href = 'https://acecn-mobile-volc-pkg-cdn.91act.com/bbee/bbee.apk'
    } else if (isHarmonyOS) {
      window.location.href = 'https://appgallery.huawei.com/app/C111687743'
    } else {
      console.log('此功能仅支持 iOS、Android 和 HarmonyOS 设备')
    }
  }
  next() // 必须调用 next() 才能让路由前进
})

export default router
